import { render } from "./localnav.vue?vue&type=template&id=5854b484&scoped=true"
import script from "./localnav.vue?vue&type=script&lang=js"
export * from "./localnav.vue?vue&type=script&lang=js"

import "./localnav.vue?vue&type=style&index=0&id=5854b484&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5854b484"],['__file',"src/js/components/localnav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5854b484"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5854b484', __exports__)) {
    api.reload('5854b484', __exports__)
  }
  
  module.hot.accept("./localnav.vue?vue&type=template&id=5854b484&scoped=true", () => {
    api.rerender('5854b484', render)
  })

}


export default __exports__